import React, { useState, useEffect } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { Table } from "../../components/Table/Table";
import { Search_icon, delete_icon_noti } from "../../assets/img";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useNavigate } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get, put, deletes } from "../../Services/ApiHandler";
import { toast } from "react-toastify";

const CreateTemplate = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const url = `${URLS.USER_NOTIFICATION_TEMPLATE_LIST}?search=${searchTerm}&page=${page}`;
      const res = await get(url);
      if (res?.status === "success" || res?.data) {
        const results = Array.isArray(res?.data) ? res.data : (res?.results || res || []);
        
        setTotalPages(res?.total_pages || 1);
        setTotalCount(res?.count || results.length);

        const mappedData = (Array.isArray(results) ? results : []).map((item, index) => ({
          ...item,
          sno: String((page - 1) * 10 + index + 1).padStart(2, "0"),
        }));
        setData(mappedData);
      } else if (Array.isArray(res)) {
        const mappedData = res.map((item, index) => ({
          ...item,
          sno: String((page - 1) * 10 + index + 1).padStart(2, "0"),
        }));
        setData(mappedData);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchTerm, page]);

  const handleDelete = async () => {
    if (!templateToDelete) return;
    try {
      const url = `${URLS.USER_NOTIFICATION_TEMPLATE_DELETE}${templateToDelete}/`;
      const res = await deletes(url);
      if (res?.status === "success" || res?.message) {
        toast.success(res?.message || "Deleted Successfully");
        setShowDeleteModal(false);
        setTemplateToDelete(null);
        fetchData();
      } else {
        toast.error("Failed to delete");
      }
    } catch (error) {
      toast.error("Error occurred while deleting");
    }
  };

  const handleStatusToggle = async (row) => {
    try {
      const url = `${URLS.USER_NOTIFICATION_STATUS_UPDATE}${row.id}/`;
      // No payload or empty payload according to active/deactive endpoint in user request
      const res = await put(url, {}); 
      if (res?.status === "success" || res?.message || res) {
        toast.success(res?.message || "Status updated successfully");
        fetchData();
      } else {
        toast.error("Failed to update status");
      }
    } catch (error) {
      toast.error("Error updating status");
    }
  };

  const columns = [
    {
      Header: "S.No",
      accessor: "sno",
      Cell: ({ row }) => <div className="text-center">{row.original.sno}</div>,
    },
    {
      Header: "Teamplate Name",
      accessor: "name",
    },
    {
      Header: "State",
      accessor: "state_names",
      Cell: ({ row }) => {
        const stateNames = (row.original.state_names || []).join(" | ");
        return <div>{stateNames}</div>;
      }
    },
    {
      Header: "City",
      accessor: "city_names",
      Cell: ({ row }) => {
        const cityNames = (row.original.city_names || []).join(" | ");
        return <div>{cityNames}</div>;
      }
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => {
        const isActive = row.original.status;
        return (
          <button 
            className="btn btn-sm d-flex align-items-center justify-content-center" 
            style={{ 
              backgroundColor: isActive ? "#1eab55" : "#e74c3c", 
              color: "white",
              border: "none", 
              borderRadius: "6px", 
              width: "80px", 
              height: "30px", 
              margin: "auto", 
              fontSize: "12px", 
              padding: "0" 
            }}
            onClick={() => handleStatusToggle(row.original)}
          >
            {isActive ? "Active" : "Inactive"} <KeyboardArrowDownIcon style={{ fontSize: "16px" }} className="ms-1" />
          </button>
        )
      },
    },
    {
      Header: "Created By",
      accessor: "created_admin_by",
    },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <div className="position-relative d-flex justify-content-center">
          <div 
            className="cursor-pointer p-1"
            onClick={(e) => {
              e.stopPropagation();
              setOpenDropdownId(openDropdownId === row.original.id ? null : row.original.id);
            }}
          >
            <MoreVertIcon 
              className="text-muted" 
              style={{ fontSize: "20px" }}
            />
          </div>
          {openDropdownId === row.original.id && (
            <div 
              className="position-absolute bg-white" 
              style={{ 
                top: "100%", right: "0%", zIndex: 10, 
                width: "90px", borderRadius: "12px", 
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                padding: "8px 0"
              }}
            >
              <div 
                className="dropdown-item py-2 px-3 text-center cursor-pointer" 
                style={{ fontSize: "15px", color: "#4b5563" }} 
                onClick={() => {
                  setOpenDropdownId(null);
                  navigate("/user-template-notification", { state: { type: "edit", data: row.original } });
                }}
              >
                Edit
              </div>
              <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "4px 16px" }}></div>
              <div 
                className="dropdown-item py-2 px-3 text-center cursor-pointer" 
                style={{ fontSize: "15px", color: "#4b5563" }} 
                onClick={() => {
                  setOpenDropdownId(null);
                  navigate("/user-template-notification", { state: { type: "view", data: row.original } });
                }}
              >
                View
              </div>
              <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "4px 16px" }}></div>
              <div 
                className="dropdown-item py-2 px-3 text-center cursor-pointer" 
                style={{ fontSize: "15px", color: "#4b5563" }} 
                onClick={() => {
                  setOpenDropdownId(null);
                  setTemplateToDelete(row.original.id);
                  setShowDeleteModal(true);
                }}
              >
                Delete
              </div>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="layout_body p-3" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      <div className="d-flex align-items-center justify-content-between header mb-3">
        <h2 className="mt-0 mb-0 ms-2 fw-bold" style={{ fontSize: "24px", color: "#000" }}>Template</h2>
        <Topbar />
      </div>

      <div className="mt-3 p-3 p-md-4 mb-4 mx-2" style={{ backgroundColor: "#f4f5f6", borderRadius: "16px" }}>
        <div className="d-flex flex-column flex-md-row align-items-md-center mb-4">
          <div style={{ flex: 1 }}>
            <h3 className="mb-1 fw-bold" style={{ fontSize: "20px", color: "#333" }}>All Teamplate</h3>
            <p className="text-muted m-0" style={{ fontSize: "14px" }}>Total No : {totalCount < 10 ? `0${totalCount}` : totalCount}</p>
          </div>
          
          <div className="search-box position-relative mt-3 mt-md-0" style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <div className="position-relative" style={{ width: "100%", maxWidth: "350px", minWidth: "250px" }}>
              <img src={Search_icon} alt="search" className="position-absolute top-50 translate-middle-y" style={{ left: "12px", width: '30px', opacity: 0.5 }} />
              <input
                type="text"
                placeholder="Teamplate Name"
                className="form-control py-2"
                style={{ paddingLeft: "40px", borderRadius: "8px", border: "1px solid #e8e8e8", width: "100%", minWidth: "250px", fontSize: "14px", backgroundColor: "#fff", height: "55px", outline: "none" }}
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPage(1);
                }}
              />
            </div>
          </div>

          <div className="mt-3 mt-md-0" style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
            <button 
              className="btn text-white px-5 py-2" 
              style={{ backgroundColor: "#c175ff", borderRadius: "8px", fontWeight: "600", fontSize: "14px", minWidth: "120px" }}
              onClick={() => navigate("/add-template")}
            >
              Create
            </button>
          </div>
        </div>

        <style>
          {`
            .custom-template-table {
              width: 100%;
              border-collapse: separate;
              border-spacing: 0 10px;
            }
            .custom-template-table thead th {
              border: none;
              font-weight: 600;
              color: #4a4a4a;
              font-size: 14px;
              padding: 10px 16px;
              text-align: left;
            }
            .custom-template-table tbody tr {
              background-color: #ffffff;
              box-shadow: 0 1px 3px rgba(0,0,0,0.02);
            }
            .custom-template-table tbody td {
              border-top: none;
              border-bottom: none;
              padding: 16px;
              vertical-align: middle;
              font-size: 14px;
              color: #555;
            }
            .custom-template-table tbody td:first-child {
              border-top-left-radius: 8px;
              border-bottom-left-radius: 8px;
            }
            .custom-template-table tbody td:last-child {
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
            }
          `}
        </style>

        <div className="table-responsive">
          <table className="custom-template-table">
            <thead>
              <tr>
                {columns.map((col, idx) => (
                  <th key={idx} className={col.Header === "S.No" || col.Header === "Status" || col.Header === "Action" ? "text-center" : ""}>
                    {col.Header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx}>
                  <td className="text-center">{row.sno}</td>
                  <td>{row.name}</td>
                  <td>
                    {(row.state_names || []).length > 2 
                      ? `${(row.state_names || []).slice(0, 2).join(" | ")} +` 
                      : (row.state_names || []).join(" | ")}
                  </td>
                  <td>
                    {(row.city_names || []).length > 2 
                      ? `${(row.city_names || []).slice(0, 2).join(" | ")} +` 
                      : (row.city_names || []).join(" | ")}
                  </td>
                  <td className="text-center">
                    <button 
                      className="btn btn-sm d-flex align-items-center justify-content-center" 
                      style={{ 
                        backgroundColor: row.status ? "#1eab55" : "#e74c3c", 
                        color: "white",
                        border: "none", 
                        borderRadius: "6px", 
                        width: "85px", 
                        height: "32px", 
                        margin: "auto", 
                        fontSize: "13px", 
                        padding: "0" 
                      }}
                      onClick={() => handleStatusToggle(row)}
                    >
                      {row.status ? "Active" : "Inactive"} <KeyboardArrowDownIcon style={{ fontSize: "16px" }} className="ms-1" />
                    </button>
                  </td>
                  <td>{row.created_admin_by}</td>
                  <td className="text-center position-relative">
                    <div 
                      className="cursor-pointer p-1 d-inline-block"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDropdownId(openDropdownId === row.id ? null : row.id);
                      }}
                    >
                      <MoreVertIcon className="text-muted" style={{ fontSize: "20px" }} />
                    </div>
                    {openDropdownId === row.id && (
                      <div 
                        className="position-absolute bg-white text-start" 
                        style={{ 
                          top: "80%", right: "30%", zIndex: 10, 
                          width: "90px", borderRadius: "12px", 
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          padding: "8px 0"
                        }}
                      >
                        <div 
                          className="dropdown-item py-2 px-3 text-center cursor-pointer" 
                          style={{ fontSize: "15px", color: "#4b5563" }} 
                          onClick={() => {
                            setOpenDropdownId(null);
                            navigate("/add-template", { state: { type: "edit", data: row } });
                          }}
                        >
                          Edit
                        </div>
                        <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "4px 16px" }}></div>
                        <div 
                          className="dropdown-item py-2 px-3 text-center cursor-pointer" 
                          style={{ fontSize: "15px", color: "#4b5563" }} 
                          onClick={() => {
                            setOpenDropdownId(null);
                            navigate("/add-template", { state: { type: "view", data: row } });
                          }}
                        >
                          View
                        </div>
                        <div style={{ height: "1px", backgroundColor: "#e5e7eb", margin: "4px 16px" }}></div>
                        <div 
                          className="dropdown-item py-2 px-3 text-center cursor-pointer" 
                          style={{ fontSize: "15px", color: "#4b5563" }} 
                          onClick={() => {
                            setOpenDropdownId(null);
                            setTemplateToDelete(row.id);
                            setShowDeleteModal(true);
                          }}
                        >
                          Delete
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Custom Pagination matching the design */}
        <div className="d-flex justify-content-center align-items-center mt-5 pb-5" style={{ gap: "20px", fontSize: "14px" }}>
           <span 
             className="cursor-pointer" 
             style={{ color: page > 1 ? "#333" : "#d1c6db", fontWeight: "500", pointerEvents: page > 1 ? "auto" : "none" }}
             onClick={() => page > 1 && setPage(page - 1)}
           >
             &lt;&lt; Previous
           </span>
           
           {[...Array(totalPages)].map((_, i) => {
             const pageNum = i + 1;
             if (
               pageNum === 1 || 
               pageNum === totalPages || 
               (pageNum >= page - 1 && pageNum <= page + 1)
             ) {
               return (
                 <span 
                   key={pageNum}
                   className="cursor-pointer" 
                   style={{ 
                     color: page === pageNum ? "#c175ff" : "#6c757d", 
                     fontWeight: page === pageNum ? "600" : "normal" 
                   }}
                   onClick={() => setPage(pageNum)}
                 >
                   {pageNum}
                 </span>
               );
             } else if (
               pageNum === page - 2 || 
               pageNum === page + 2
             ) {
               return <span key={pageNum} className="text-muted">....</span>;
             }
             return null;
           })}

           <span 
             className="cursor-pointer" 
             style={{ color: page < totalPages ? "#333" : "#d1c6db", fontWeight: "500", pointerEvents: page < totalPages ? "auto" : "none" }}
             onClick={() => page < totalPages && setPage(page + 1)}
           >
             Next <span style={{ color: page < totalPages ? "#c175ff" : "#d1c6db" }}>&gt;&gt;</span>
           </span>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: "rgba(0,0,0,0.2)", zIndex: 1050 }}>
          <div className="bg-white p-4 text-center d-flex flex-column align-items-center" style={{ borderRadius: "24px", width: "420px", boxShadow: "0 10px 30px rgba(0,0,0,0.1)" }}>
            <img src={delete_icon_noti} alt="delete" className="mb-3 mt-2" style={{ width: "50px", height: "auto" }} />
            <h4 className="fw-bold mb-3" style={{ color: "#000", fontSize: "20px" }}>Delete</h4>
            <p className="text-muted mb-4 pb-2" style={{ fontSize: "16px", color: "#777" }}>Are You Sure You Want To Delete ?</p>
            <div className="d-flex justify-content-center gap-3 w-100 mb-2">
              <button 
                className="btn bg-white flex-grow-1" 
                style={{ border: "1px solid #dcdcdc", borderRadius: "8px", padding: "10px 0", color: "#555", fontWeight: "600", fontSize: "14px" }}
                onClick={() => setShowDeleteModal(false)}
              >
                Cancell
              </button>
              <button 
                className="btn text-white flex-grow-1" 
                style={{ backgroundColor: "#b863f8", borderRadius: "8px", padding: "10px 0", fontWeight: "600", fontSize: "14px", border: "none" }}
                onClick={handleDelete}
              >
                confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateTemplate;
